import axios from "axios";
import moment from "moment";
import { Dispatch } from "react";
import { Action } from "redux";
import { getApiUrl, setDataToLs } from "../../helper/functions";
import * as Types from "../types";
import { setAlert } from "./Actions";

let API_URL = getApiUrl();

// Auth

export const setCurrUser = (currUser: CurrUser) => {
    return {
        type: Types.SET_CURR_USER,
        payload: {
            currUser,
        },
    };
};

export const getCurrUser = () => {
    return {
        type: Types.GET_USER,
    };
};
export const logoutCurrUser = () => {
    return {
        type: Types.LOGOUT,
    };
};

// Register

export const register: Register = (
    username,
    password1,
    password2,
    first_name,
    last_name,
    email
) => (dispatch: Dispatch<Action>) => {
    const path = `${API_URL}/auth/v1/register/`;
    axios
        .post(path, {
            username: username,
            password1: password1,
            password2: password2,
            first_name: first_name,
            last_name: last_name,
            email: email,
        })
        .then((res) => {
            if (res.status === 201) {
                dispatch(
                    setAlert(
                        "success",
                        "User Registered Successfully!",
                        "success"
                    )
                );

                window.location.href = "/login";
            }
        })
        .catch((err) => {
            if (err.response?.data.username !== undefined) {
                dispatch(setAlert("danger", "Username Exist!", "error"));
            } else if (err.response?.data.email !== undefined) {
                dispatch(setAlert("danger", "Email Exist!", "error"));
            } else if (
                err.response?.data.password1 !== undefined &&
                err.response?.data.password1[0].trim() ===
                    "This password is too common."
            ) {
                dispatch(setAlert("danger", "Password is too common", "error"));
            }
        });
};

// Login
export const login: Login = (username, password) => (
    dispatch: Dispatch<Action>
) => {
    const path = `${API_URL}/auth/v1/login/`;
    axios
        .post(path, {
            username: username,
            password: password,
        })
        .then((res) => {
            if (res.status === 200) {
                setDataToLs("last_login", moment.now());
            }

            const newCurrUser: CurrUser = {
                id: res.data.user.key,
                first_name: res.data.user.first_name,
                last_name: res.data.user.last_name,
                username: res.data.user.username,
                email: res.data.user.email,
                access: res.data.tokens.access,
                refresh: res.data.tokens.refresh,
            };

            dispatch(setCurrUser(newCurrUser));
            window.location.href = "/dashboard";
        })
        .catch((err) => {
            console.log(err.response);

            if (err.response?.status === 401) {
                dispatch(
                    setAlert(
                        "danger",
                        "Username or password is wrong!",
                        "error"
                    )
                );
            }
        });
};

// Logout
export const logout = (accessToken: string, refreshToken: string) => (
    dispatch: Dispatch<Action>
) => {
    const path = `${API_URL}/auth/v1/dashboard/logout/`;

    if (accessToken !== "" && refreshToken !== "") {
        axios
            .post(
                path,
                {
                    refresh_token: refreshToken,
                },
                {
                    headers: {
                        Authorization: `Bearer ${accessToken}`,
                    },
                }
            )
            .then((res) => {
                if (res.status === 205) {
                    dispatch(logoutCurrUser());
                }

                window.location.href = "/";
            })
            .catch((err) => {
                console.log(err.response);
                if (err.response?.status === 400) {
                    console.log("Not loged in at all!");
                }
                if (
                    (err.response?.status === 401 &&
                        err.response?.data.code === "token_not_valid") ||
                    err.response?.statusText === "Unauthorized"
                ) {
                    localStorage.clear();
                    window.location.href = "/";
                }
            });
    }
};

// Edit Profile

export const updateCurrUser: UpdateCurrUser = (
    first_name,
    last_name,
    username,
    email
) => {
    return {
        type: Types.UPDATE_CURR_USER,
        payload: {
            first_name,
            last_name,
            username,
            email,
        },
    };
};

export const editProfile: EditProfile = (
    first_name,
    last_name,
    username,
    email,
    key,
    accessToken
) => (dispatch: Dispatch<any>) => {
    const path = `${API_URL}/auth/v1/dashboard/update_profile/${key}/`;
    axios
        .put(
            path,
            {
                first_name: first_name,
                last_name: last_name,
                username: username,
                email: email,
            },
            {
                headers: {
                    Authorization: `Bearer ${accessToken}`,
                },
            }
        )
        .then((res) => {
            if (res.status === 200) {
                dispatch(
                    updateCurrUser(first_name, last_name, username, email)
                );
                dispatch(
                    setAlert(
                        "success",
                        "Profile updated successfully!",
                        "success"
                    )
                );
            }
        })
        .catch((err) => {
            console.log(err.response);
            if (err.response?.data.username !== undefined) {
                dispatch(setAlert("danger", "Username Exist!", "error"));
            } else if (err.response?.data.email !== undefined) {
                dispatch(setAlert("danger", "Email Exist!", "error"));
            }
        });
};
